import Vue from 'vue'
import FILE_STATES from './file-states.js'

const MAX_UPLOADING_FILES = 10

export default new Vue({
  data () {
    return {
      isDownloading: false,
      files: {},
      filesByState: {
        [FILE_STATES.pending]: {},
        [FILE_STATES.downloading]: {},
        [FILE_STATES.completed]: {},
        [FILE_STATES.error]: {},
        [FILE_STATES.canceled]: {}
      }
    }
  },
  methods: {
    processPending () {
      const uploadingKeys = Object.keys(this.filesByState[FILE_STATES.downloading])
      const pendingKeys = Object.keys(this.filesByState[FILE_STATES.pending])

      if (pendingKeys.length > 0 && uploadingKeys.length < MAX_UPLOADING_FILES) {
        this.downloadFile(pendingKeys[0])
      }
    },
    addFile (file) {
      return new Promise((resolve, reject) => {
        const statefulFile = Object.assign({}, {
          state: FILE_STATES.pending,
          progress: 0,
          request: file.request,
          resolve,
          reject
        }, file)
        const fileUID = file.uuid
        this.files = Object.assign({}, this.files, {[fileUID]: statefulFile})
        this.filesByState[FILE_STATES.pending][fileUID] = statefulFile
        this.updateFileState(fileUID, FILE_STATES.pending)
        resolve()
      })
    },
    updateFileState (key, state) {
      if (state[Symbol.toStringTag] === 'FileState') {
        const oldState = this.files[key].state
        if (oldState === FILE_STATES.completed) {
          this.processPending()
          return
        }

        this.files[key].state = state
        this.files = Object.assign({}, this.files)

        this.filesByState[state][key] = this.files[key]

        if (oldState !== state) {
          if (this.filesByState[oldState] && this.filesByState[oldState][key]) {
            delete this.filesByState[oldState][key]
          }
        }

        this.filesByState = Object.assign({}, this.filesByState)
        this.processPending()
      } else {
        console.error('File state must be FileState instance, instead got: ', state[Symbol.toStringTag])
      }
    },
    updateFileProgress (key, progress) {
      this.updateFileState(key, FILE_STATES.downloading)
      this.files[key].progress = progress > 100 ? 100 : progress
      this.files = Object.assign({}, this.files)
    },
    updateFileRequest (key, request) {
      this.files[key].request = request
      this.files = Object.assign({}, this.files)
    },
    abortDownload (key) {
      const data = this.files[key]
      if (data.request !== undefined) {
        data.request.then(xhr => {
          xhr.abort()
          this.updateFileState(key, FILE_STATES.canceled)
          this.updateFileProgress(key, 0)
        })
      } else {
        console.warn('Can\'t abort download, request promise doesn\'t exists yet.')
      }
    },
    downloadFile (key) {
      const data = this.files[key]
      return new Promise((resolve) => {
        if (data.request) {
          this.updateFileProgress(key, 0)
          data.request().then(() => { this.updateFileState(data.uuid, FILE_STATES.completed) })
        }
        resolve()
      }).then(response => {
        data.resolve({data, response})
        return response
      }, () => {
        data.reject(data)
        if (!data.state.equals(FILE_STATES.canceled)) {
          this.updateFileState(key, FILE_STATES.error)
        }
      })
    },
    clearFiles () {
      this.files = {}
      this.filesByState = {
        [FILE_STATES.pending]: {},
        [FILE_STATES.downloading]: {},
        [FILE_STATES.completed]: {},
        [FILE_STATES.error]: {},
        [FILE_STATES.canceled]: {}
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/plugins/uploader/download-state.js